// 客户合同管理列表
import { HttpGetCusContactList,HttpDeleteCusContactPort } from '@/service/basicdata';
import TableList from "@components/templates/tablelist";
import {  mapGetters } from 'vuex';
import comIndex from './update'

export default {
    mixins: [TableList],
    components: {
        comIndex,
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpGetCusContactList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case 'add':
                    this.$router.push({
                        name: 'basicdataCustomercontractUpdate',
                        params: { type: "add" },
                    });
                    break;
                case 'query':
                        // var url = this.$router.resolve({
                        //     name: "basicdataCustomercontractUpdate",
                        //     params: { type: "query" },
                        //     query: { id: params },
                        // });
                        // window.open(url.href, '_blank');
                        this.operate = {
                            title: '查看',
                            show:true,
                            width:1000,
                            component: "comIndex",
                            activeid:params,
                            querytype:'query',
                            showFooter:false,
                        }
                        break;
                case 'edit':
                    this.$router.push({
                        name: 'basicdataCustomercontractUpdate',
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    break;
                case "export":
                        this.handleWebfs(
                            process.env.VUE_APP_APIURL_FBB + "/api/v2/customerContract/export", this.formData,
                            {
                                executor: "request",
                                download: true,
                                method: 'post'
                            }
                        );
                        break;
                case "delete":
                    this.operate={
                        show:true,
                        alert: "error",
                        title:this.$t('global.common.operate_delete', { defaultValue: "删除" }),
                        width:460,
                        params:{id:params},
                        ajaxRequest:HttpDeleteCusContactPort
                    }
            }
        },
        getOperateNodeMap(row) {
            const { id } = row;
            return [{
                label: this.$t('global.common.query', { defaultValue: "查看" }),
                show: this.handleAuth('fbb.customerContract.view'),
                params: id,
                operate: 'query'
            }, {
                label: this.$t('global.common.edit', { defaultValue: '编辑' }),
                show: this.handleAuth('fbb.customerContract.edit'),
                params: id,
                operate: 'edit'
            },
            {
                label: this.$t('global.common.delete', { defaultValue: '删除' }),
                show: this.handleAuth('fbb.customerContract.edit'),
                params:id,
                operate:'delete'
            }
            ]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList', 'getBillcusWareList','getCarrierAll']),
        ToolsData() {
            return [
                {
                    name: "添加",
                    operate: "add",
                    theme: "primary",
                    show: this.handleAuth('fbb.customerContract.edit'),
                },
                {
                    name: this.$t('global.common.export', { defaultValue: "导出" }),
                    operate: "export",
                    theme: "success",
                    show: this.handleAuth('fbb.customerContract.export'),
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: "合同类型",
                    key: 'EQ_contractType',
                    show: true,
                    tag: 'vSelect',
                    options: [
                        {  value:1,label:'客户销售合同' },
                        {  value:2,label:'供应商采购合同' }
                    ],
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: "合同名称",
                    key: 'CN_contractName',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: "客户公司名称",
                    key: 'CN_customerCompanyName',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: "客户组织名称",
                    key: 'EQ_orgId',
                    tag: 'vSelect',
                    options: this.getBillcusorgList,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: "仓库",
                    key: 'EQ_warehouseCode',
                    tag: 'vSelect',
                    options: this.getBillcusWareList.map(item=>{
                        return {
                            label:item.label,
                            value:item.attach.code
                        }
                    }),
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: "承运商",
                    key: 'EQ_carrierCode',
                    tag: 'vSelect',
                    options: this.getCarrierAll,
                    props: {
                        filterable: true,
                    },
                },
            ]
        },
        columns() {
            return [
                {
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },
                {
                    title:'No.',
                    width:40,
                    type:"index"
                },
                {
                    title: this.$t('global.common.operation', { defaultValue: '操作' }),
                    maxWidth: 90,
                    render: this.getOperateNodes
                }, {
                    title: '合同类型',
                    key: 'contractType',
                    render: (h, { row }) => {
                        return <div>
                            {row.contractType == 1 ? '客户销售合同' : row.contractType == 2 ? '供应商采购合同' : ''}
                        </div>
                    }
                },
                {
                    title: '合同名称',
                    render: (h, { row }) => {
                        return <div>
                            <div>
                                <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.contractName || '--'}</a>
                            </div>
                        </div>
                    }
                },
                {
                    title: '客户公司名称',
                    key: 'customerCompanyName',
                },
                {
                    title: '签约对象',
                    key: 'signTarget',
                },
                {
                    title: '客户组织名称'+'/'+'仓库'+'/'+'承运商',
                    render: (h, { row }) => {
                        return <div>
                            <div>{row.orgName || '--'}</div>
                            <div>{row.warehouseCode || '--'}</div>
                            <div>{row.carrierCode || '--'}</div>
                        </div>
                    }
                },
                {
                    title: '合同签订日期',
                    key: 'signDate',
                },
                {
                    title: '签约年限（年）',
                    key: 'signYears',
                },
                {
                    title: '签约起始日'+'/'+'签约到期日',
                    render: (h, { row }) => {
                        return <div>
                            <div>{row.signStartDate}</div>
                            <div>{row.signEndDate}</div>
                        </div>
                    },
                },
                {
                    title: '更新时间',
                    key: 'updatedAt',
                },
            ];
        },
    },
};




